import React from 'react';
import warning from '../../../assets/icons/ic_info_warning.svg';
import info from '../../../assets/icons/ic_info_light.svg';
import success from '../../../assets/icons/ic_success.svg';
import PropTypes from 'prop-types';

const TOAST_ICONS = {
	info,
	success,
	warning
};

const CustomToast = ({ message, type = 'warning' }) => (
	<div
		style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
		className="custom-toast-content" // Add this class here
	>
		<img
			style={{ width: '22px', height: '22px' }}
			src={TOAST_ICONS[type] || warning}
			alt={`${type} icon`}
		/>
		<p style={{ marginTop: '10px', textAlign: 'center' }}>{message}</p>
	</div>
);

CustomToast.propTypes = {
	message: PropTypes.string,
	type: PropTypes.oneOf(['info', 'success', 'warning'])
};

export default CustomToast;
